import { Box, Typography } from "@mui/material";
import CustomIcon from "../../../Components/CustomIcon";
import { PrimaryTooltip } from "../../../Components/StyledComponent";
import { getMetricTimeStamp } from "../../../Helper/DatePicker/DateConverter";

const OverdueBadge = ({ overdueSince }) => {
    const relativeTimestamp = overdueSince ? getMetricTimeStamp(overdueSince, 'relative') : null;
    return (
        <PrimaryTooltip
            title={relativeTimestamp ? `Overdue since ${relativeTimestamp}` : ''}
            placement="bottom"
        >
            <Box
                sx={{
                    border: '1px solid #FFAEAB',
                    borderRadius: '4px',
                    px: 1,
                    py: 0.25,
                    bgcolor: '#FFE4E4',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: 0.5,
                }}
            >
                <CustomIcon name="clock" stroke="#686868" />
                <Typography variant="fw500s12c686868" sx={{color: '#494949', lineHeight: '20px'}}>
                    Overdue
                </Typography>
            </Box>
        </PrimaryTooltip>
    )
}

export default OverdueBadge;
